var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import gql from 'graphql-tag';
import React from 'react';
import { useODMutation, useODQuery } from '../../../hooks';
var gqlQueryPlaceholder = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query placeholderQuery {\n    youShouldNotSeeThisInAction\n  }\n"], ["\n  query placeholderQuery {\n    youShouldNotSeeThisInAction\n  }\n"])));
var gqlMutationPlaceholder = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation placeholderMutation {\n    youShouldNotSeeThisInAction\n  }\n"], ["\n  mutation placeholderMutation {\n    youShouldNotSeeThisInAction\n  }\n"])));
export function useODEntityAPI(options) {
    var _this = this;
    var mapServerDataToClientData = options.mapServerDataToClientData, mapClientDataToServerUpdate = options.mapClientDataToServerUpdate, mapClientDataToServerCreate = options.mapClientDataToServerCreate, pk = options.primaryKeyName;
    var primaryKeyName = pk;
    var createAPI = useODMutation(options.createGQL || gqlMutationPlaceholder);
    var readAPI = useODQuery(options.readGQL || gqlQueryPlaceholder);
    var readLatestAPI = useODQuery(options.readLatestGQL || gqlQueryPlaceholder);
    var updateAPI = useODMutation(options.updateGQL || gqlMutationPlaceholder);
    var deleteAPI = useODMutation(options.deleteGQL || gqlMutationPlaceholder);
    var createEntityAPI = React.useCallback(function () {
        var api = {
            create: options.createGQL
                ? function (clientValue) { return __awaiter(_this, void 0, void 0, function () {
                    var _a, idToIgnore, values, createInput, serverData;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = primaryKeyName, idToIgnore = clientValue[_a], values = __rest(clientValue, [typeof _a === "symbol" ? _a : _a + ""]);
                                createInput = mapClientDataToServerCreate
                                    ? mapClientDataToServerCreate(values)
                                    : values;
                                return [4 /*yield*/, createAPI(createInput)];
                            case 1:
                                serverData = _b.sent();
                                if (mapServerDataToClientData) {
                                    return [2 /*return*/, mapServerDataToClientData(serverData)];
                                }
                                // default mapServerDataToClientData
                                return [2 /*return*/, serverData];
                        }
                    });
                }); }
                : undefined,
            load: options.readGQL
                ? function (id) { return __awaiter(_this, void 0, void 0, function () {
                    var serverData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, readAPI({ id: id })];
                            case 1:
                                serverData = _a.sent();
                                if (mapServerDataToClientData) {
                                    return [2 /*return*/, mapServerDataToClientData(serverData)];
                                }
                                return [2 /*return*/, serverData];
                        }
                    });
                }); }
                : undefined,
            loadLatest: options.readLatestGQL
                ? function () { return __awaiter(_this, void 0, void 0, function () {
                    var serverData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, readLatestAPI({ ignoreMe: null })];
                            case 1:
                                serverData = _a.sent();
                                if (mapServerDataToClientData) {
                                    return [2 /*return*/, mapServerDataToClientData(serverData)];
                                }
                                return [2 /*return*/, serverData];
                        }
                    });
                }); }
                : undefined,
            update: options.updateGQL
                ? function (changedClientValue, originalClientValue) { return __awaiter(_this, void 0, void 0, function () {
                    var id, updateInput, serverData, updateInput, serverData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!!options.readLatestGQL) return [3 /*break*/, 2];
                                id = originalClientValue[primaryKeyName];
                                updateInput = mapClientDataToServerUpdate
                                    ? mapClientDataToServerUpdate(changedClientValue, originalClientValue)
                                    : changedClientValue;
                                return [4 /*yield*/, updateAPI(__assign({ id: id }, updateInput))];
                            case 1:
                                serverData = _a.sent();
                                if (mapServerDataToClientData) {
                                    return [2 /*return*/, mapServerDataToClientData(serverData)];
                                }
                                return [2 /*return*/, serverData];
                            case 2:
                                updateInput = mapClientDataToServerUpdate
                                    ? mapClientDataToServerUpdate(changedClientValue, originalClientValue)
                                    : changedClientValue;
                                return [4 /*yield*/, updateAPI(updateInput)];
                            case 3:
                                serverData = _a.sent();
                                if (mapServerDataToClientData) {
                                    return [2 /*return*/, mapServerDataToClientData(serverData)];
                                }
                                return [2 /*return*/, serverData];
                        }
                    });
                }); }
                : undefined,
            delete: options.deleteGQL
                ? function (loadedClientValue) { return __awaiter(_this, void 0, void 0, function () {
                    var id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = loadedClientValue[primaryKeyName];
                                return [4 /*yield*/, deleteAPI({ id: id })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
                : undefined,
        };
        return api;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        primaryKeyName,
        createAPI,
        readAPI,
        updateAPI,
        deleteAPI,
        mapClientDataToServerCreate,
        mapServerDataToClientData,
        mapClientDataToServerUpdate,
    ]);
    var apis = React.useState(function () {
        return createEntityAPI();
    })[0];
    return apis;
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=useODEntityAPI.js.map